module.exports = __webpack_public_path__ + "static/treesome-logo.1222d0cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/treesome-logo.svg
// module id = 141
// module chunks = 94551500655095 213534597649335